import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { AllActionTypes } from "@/store/action-types";
import { inject, onBeforeMount } from "vue";
import { useStore } from "@/shared/composables/useStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RefreshToken',
    setup(__props) {
        const store = useStore();
        const authService = inject("authService");
        onBeforeMount(() => {
            store.dispatch(AllActionTypes.REFRESH_TOKEN, authService);
            load();
        });
        //TODO: Make sure that refreshing the token every 2 minutes is really necessary
        const load = () => {
            window.setInterval(function () {
                store.dispatch(AllActionTypes.REFRESH_TOKEN, authService);
            }, 120000);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div"));
        };
    }
});
